import React, { Component } from "react";
import "./ApplianceLogDebug.scss";
import AdminActions from "../../actions/adminActions";
import AdminStore from "../../stores/adminStore";
import BuildingActions from "../../actions/buildingActions";
import BuildingStore from "../../stores/buildingStore";
import GeneralStore from "../../stores/generalStore";
import { HighChart } from "../../components/HighChart";
import { SearchSelect } from "../../components/SearchSelect";
import { DocumentTitle } from "../../components/DocumentTitle";
import { LogoSpinner } from "../../components/LogoSpinner";
import _ from "lodash";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class ApplianceLogDebug extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ts_start: GeneralStore.getStartDate(),
      ts_end: GeneralStore.getEndDate(),
      selected_point: null,
      selected_controller: null,
      selected_appliance: null,
      selected_category: null,
      selected_property: null,
      selected_building: null,
      available_buildings: BuildingStore.getBuildings(),
      available_properties: AdminStore.getAvailableProperties(),
      available_categories: AdminStore.getAvailableCategories(),
      available_appliances: AdminStore.getAvailableAppliances(),
      available_controllers: AdminStore.getAvailableControllers(),
      unique_points: AdminStore.getUniquePoints(),
      searchInput: "",
      loading: true,
    };
    this._onPointsChange = this._onPointsChange.bind(this);
    this._onFilterInput = this._onFilterInput.bind(this);
    this._selectBuilding = this._selectBuilding.bind(this);
    this._selectAppliance = this._selectAppliance.bind(this);
    this._selectController = this._selectController.bind(this);
    this._selectCategory = this._selectCategory.bind(this);
    this._selectProperty = this._selectProperty.bind(this);
    this._onDateChange = this._onDateChange.bind(this);
  }

  componentWillMount() {
    GeneralStore.addChangeListener(this._onDateChange);
    AdminStore.addChangeListener(this._onPointsChange);
  }
  componentWillUnmount() {
    AdminStore.clear();
    GeneralStore.removeChangeListener(this._onDateChange);
    AdminStore.removeChangeListener(this._onPointsChange);
  }
  componentDidMount() {
    this.fetchBuildings();
  }

  async fetchBuildings() {
    const buildings = await BuildingActions.getBuildings();
    this.setState({
      available_buildings: buildings,
      loading: false,
    });
  }

  fetchData(appliance_id, controllerName, ts_start) {
    this.setState({ loading: true });
    AdminActions.getUniquePoints(appliance_id, controllerName, ts_start);
  }

  fetchAppliances(building_id) {
    this.setState({ loading: true });
    AdminActions.getAppliances(building_id);
  }

  _selectBuilding(selected_building) {
    this.setState(
      {
        selected_building,
        selected_appliance: null,
        selected_controller: null,
        selected_category: null,
        selected_property: null,
        searchInput: "",
      },
      this.fetchAppliances(selected_building.building_id)
    );
  }
  _onDateChange() {
    const ts_start = GeneralStore.getStartDate();
    const ts_end = GeneralStore.getEndDate();

    this.setState(
      {
        ts_start,
        ts_end,
      },
      () => {
        if (this.state.selected_appliance && this.state.selected_controller) {
          this.fetchData(
            this.state.selected_appliance.appliance_id,
            this.state.selected_controller.name,
            ts_start
          );

          if (this.state.selected_point != null) {
            AdminActions.getPointValues(
              this.state.selected_point,
              ts_start,
              ts_end
            );
          }
        }
      }
    );
  }
  _onPointsChange() {
    this.setState({
      available_properties: AdminStore.getAvailableProperties(),
      available_categories: AdminStore.getAvailableCategories(),
      available_controllers: AdminStore.getAvailableControllers(),
      unique_points: AdminStore.getUniquePoints(),
      available_appliances: AdminStore.getAvailableAppliances(),
      loading: false,
    });
  }
  _selectAppliance(selected_appliance) {
    if (selected_appliance.status !== "ready") {
      toast("Warning, selected appliance is disabled", {
        type: toast.TYPE.WARNING,
        autoClose: 3000,
        preventDuplicated: true,
      });
    }
    if (selected_appliance.log_enabled === false) {
      toast("Warning, selected appliance has its logging disabled", {
        type: toast.TYPE.WARNING,
        autoClose: 3000,
        preventDuplicated: true,
      });
    }
    AdminActions.getApplianceControllers(selected_appliance.appliance_id);
    this.setState({
      selected_appliance: selected_appliance,
      selected_controller: null,
      selected_category: null,
      selected_property: null,
      searchInput: "",
    });
  }
  _selectController(selected_controller) {
    this.setState(
      {
        selected_controller: selected_controller,
        loading: true,
        selected_category: null,
        selected_property: null,
        searchInput: "",
      },
      () => {
        if (this.state.selected_appliance !== null) {
          this.fetchData(
            this.state.selected_appliance.appliance_id,
            selected_controller.name,
            this.state.ts_start
          );
        }
      }
    );
  }
  _selectCategory(selected_category) {
    this.setState({ selected_category: selected_category });
  }
  _selectProperty(selected_property) {
    this.setState({ selected_property: selected_property });
  }
  _onFilterInput(event) {
    this.setState({ searchInput: event.target.value });
  }
  getTableHeader() {
    return (
      <thead>
        <tr>
          <th
            className="wd-25p tx-mont tx-medium"
            style={{ cursor: "pointer" }}
          >
            Name
          </th>
          <th className="wd-25p tx-10-force tx-mont tx-medium tx-center">
            Description
          </th>
          <th className="wd-20p tx-10-force tx-mont tx-medium tx-center">
            Category
          </th>
          <th className="wd-20p tx-10-force tx-mont tx-medium tx-center">
            Property
          </th>
          <th className="wd-10p tx-10-force tx-mont tx-medium tx-center">
            Probability
          </th>
        </tr>
      </thead>
    );
  }
  getPointValues(point) {
    AdminActions.getPointValues(point, this.state.ts_start, this.state.ts_end);
    this.setState({ selected_point: point });
  }
  getPointRows() {
    let searchValue = this.state.searchInput;
    let displayPoints = this.state.unique_points;

    if (
      this.state.selected_category &&
      this.state.selected_category.name !== "ALL CATEGORIES"
    ) {
      displayPoints = _.filter(
        displayPoints,
        function (obj) {
          return (
            obj.suggested_category.toUpperCase() ===
            this.state.selected_category.name.toUpperCase()
          );
        }.bind(this)
      );
    }

    if (
      this.state.selected_property &&
      this.state.selected_property.name !== "ALL PROPERTIES"
    ) {
      displayPoints = _.filter(
        displayPoints,
        function (obj) {
          return (
            obj.suggested_property.toUpperCase() ===
            this.state.selected_property.name.toUpperCase()
          );
        }.bind(this)
      );
    }

    if (this.state.searchInput && this.state.searchInput.length > 0) {
      displayPoints = _.filter(displayPoints, function (obj) {
        return (
          obj.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1 ||
          obj.description.toLowerCase().indexOf(searchValue.toLowerCase()) !==
          -1
        );
      });
    }

    if (displayPoints.length === 0) {
      return (
        <tr>
          <td className="valign-middle">
            <div className="d-flex align-items-center">
              <div>
                <div className="tx-inverse">No points available.</div>
              </div>
            </div>
          </td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
          <td className="valign-middle tx-center"></td>
        </tr>
      );
    } else {
      return displayPoints.map((point, key) => {
        return (
          <tr
            key={key}
            className="hover-row"
            onClick={() => this.getPointValues(point)}
          >
            <td className="valign-middle">
              <div className="d-flex align-items-center">
                <div>
                  <div className="tx-inverse">{point.name}</div>
                </div>
              </div>
            </td>
            <td className="valign-middle tx-center">{point.description}</td>
            <td className="valign-middle tx-center">
              {point.suggested_category
                ? point.suggested_category.toUpperCase()
                : "N/A"}
            </td>
            <td className="valign-middle tx-center">
              {point.suggested_property ? point.suggested_property : "N/A"}
            </td>
            <td className="valign-middle tx-center">
              {point.suggested_probability
                ? Math.round(point.suggested_probability)
                : "0"}{" "}
              %
            </td>
          </tr>
        );
      });
    }
  }
  getPointChart() {
    let chart_data = AdminStore.getPointValues();
    let chart_id = "DebugChart1";
    let title = "Select A Point";
    if (chart_data && chart_data.length > 0) {
      title = chart_data[0].name;
      return (
        <div className="row mg-t-20 mg-b-20">
          <div className="col-12 col-sm-12">
            <div className="card bd-0 shadow-base">
              {this.getChartHeaderContent(title)}
              <div
                className="card-body bd pd-b-0"
                style={{ backgroundColor: "#fff", height: "230px" }}
              >
                <HighChart
                  main_type="line"
                  exporting={true}
                  series={chart_data}
                  dataType={""}
                  chart_Tag={chart_id}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  getChartHeaderContent(title) {
    return (
      <div className="card-header bg-transparent pd-x-25 pd-y-15 bd d-flex justify-content-between align-items-center">
        <div style={{ float: "left" }}>
          <h6
            className="card-title tx-uppercase tx-12 mg-b-0"
            style={{ float: "left", marginTop: "6px" }}
          >
            {title}
          </h6>
        </div>
      </div>
    );
  }
  render() {
    const list_shown =
      this.state.selected_appliance &&
      this.state.selected_controller &&
      this.state.selected_building;

    return (
      <div
        className="br-mainpanel br-profile-body floorplan-background"
        id="ApplianceLogDebug"
      >
        <DocumentTitle title={"Appliance Log Debug"} />
        <LogoSpinner loading={this.state.loading} />
        <div className="br-container">
          <div className="row">
            <div className="col mg-t-15">
              <div className="card pd-30 mg-t-30 shadow-base bd-0 mg-t-10">
                <div className="row">
                  <div className="col-12 col-sm-12">
                    <div className="row pd-t-6">
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={999}
                          options={this.state.available_buildings}
                          placeholder={"Select Building..."}
                          defaultValue={this.state.selected_building}
                          actionOnSelectedOption={this._selectBuilding}
                        />
                      </div>
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={999}
                          options={this.state.available_appliances}
                          placeholder={"Select Appliance..."}
                          defaultValue={this.state.selected_appliance}
                          actionOnSelectedOption={this._selectAppliance}
                        />
                      </div>
                      <div className="col-12 col-sm-4">
                        <SearchSelect
                          limit={999}
                          options={this.state.available_controllers}
                          placeholder={"Select Controller..."}
                          defaultValue={this.state.selected_controller}
                          actionOnSelectedOption={this._selectController}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {list_shown ? (
                  <div className="row mg-b-5">
                    <div className="col-12 col-sm-12">
                      <hr />
                      <div className="bd-0 mg-t-10">
                        <div
                          className="bd-0 pd-b-0 pd-t-0"
                          style={{ backgroundColor: "#fff" }}
                        >
                          <div className="row mg-t-10">
                            <div
                              className="col-4 col-sm-4"
                              style={{ marginBottom: "5px", marginTop: "5px" }}
                            >
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">
                                    <ion-icon name="search" size="small" />
                                  </span>
                                </div>
                                <input
                                  defaultValue={this.state.searchInput}
                                  type="text"
                                  className="form-control"
                                  placeholder="Filter by name and description"
                                  onChange={this._onFilterInput}
                                />
                              </div>
                            </div>
                            <div
                              className="col-4 col-sm-4"
                              style={{ marginBottom: "5px", marginTop: "8px" }}
                            >
                              <SearchSelect
                                limit={999}
                                options={this.state.available_categories}
                                placeholder={"Select Point Category..."}
                                defaultValue={this.state.selected_category}
                                actionOnSelectedOption={this._selectCategory}
                              />
                            </div>
                            <div
                              className="col-4 col-sm-4"
                              style={{ marginBottom: "5px", marginTop: "8px" }}
                            >
                              <SearchSelect
                                limit={999}
                                options={this.state.available_properties}
                                placeholder={"Select Point Property..."}
                                defaultValue={this.state.selected_property}
                                actionOnSelectedOption={this._selectProperty}
                              />
                            </div>
                          </div>
                          <hr />
                          <div
                            className="row mg-t-0 mg-b-5"
                            style={{ maxHeight: "280px", overflowY: "scroll" }}
                          >
                            <div
                              className="col-12"
                              style={{ marginBottom: "5px", marginTop: "5px" }}
                            >
                              <table className="table mg-b-0 table-contact">
                                {this.getTableHeader()}
                                <tbody>{this.getPointRows()}</tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row mg-t-10">
                    <div className="col-12 col-sm-12 col-md-12 mg-b-15">
                      <div className="card bd-0 shadow-base">
                        <div
                          className="card-body bd pd-b-0 pd-t-0"
                          style={{
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "60px 0",
                          }}
                        >
                          <h4 className="tx-bold mg-b-20 tx-center">
                            Appliance Log Debug
                          </h4>
                          <p className="mg-x-20 tx-center">
                            <ion-icon
                              name="construct"
                              style={{ fontSize: "48px" }}
                            />
                          </p>
                          <h4 className="tx-default tx-center">
                            {" "}
                            Please select the building, appliance and controller
                            to filter points from.
                          </h4>
                          <p className="tx-center">
                            Once all selections are made then the available data
                            points will populate.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.getPointChart()}
        </div>
      </div>
    );
  }
}

export default ApplianceLogDebug;
